import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";

const VARIANTS = {
  gold: "bg-gold-metal text-ink shadow-[0_10px_30px_-12px_rgba(201,165,76,0.6)] hover:bg-[position:100%_50%]",
  outline: "border border-white/30 text-white hover:border-gold hover:text-gold-light",
  plum: "bg-plum text-white hover:bg-plum-2",
  ink: "bg-ink text-white hover:bg-plum",
  outlineDark: "border border-ink/25 text-ink hover:border-plum hover:text-plum",
};

const base =
  "group inline-flex min-h-[48px] items-center justify-center gap-2.5 rounded-full px-6 text-[13px] font-semibold uppercase tracking-[0.14em] transition-[background-color,background-position,border-color,color,transform] duration-500 active:scale-[0.98] focus-visible:outline-gold";

export const CtaButton = ({ to, href, children, variant = "gold", className, icon = true, testid, ...rest }) => {
  const cls = cn(base, VARIANTS[variant], className);
  const inner = (
    <>
      <span>{children}</span>
      {icon && (
        <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
      )}
    </>
  );
  if (to) return <Link to={to} className={cls} data-testid={testid} {...rest}>{inner}</Link>;
  if (href) return <a href={href} className={cls} data-testid={testid} target="_blank" rel="noopener noreferrer" {...rest}>{inner}</a>;
  return <button className={cls} data-testid={testid} {...rest}>{inner}</button>;
};
